import {
  AfterViewInit,
  Component,
  ElementRef,
  forwardRef,
  inject,
  Input,
  OnDestroy,
  OnInit
} from '@angular/core';
import {Parent} from "@wms/app/parent";
import { WmsSplitPaneComponent } from "./wms-split-pane/wms-split-pane.component";
import $ from 'jquery';
import {CommonModule} from "@angular/common";
import {EventManagerService} from "@wms/app";
import { Subscription } from "rxjs";

let resizeTimer: any;

@Component({
  selector: '[wms-split-panel]',
  standalone: true,
  template: `<ng-content></ng-content>`,
  providers: [
    {
      provide: Parent,
      useExisting: forwardRef(() => WmsSplitPanelComponent)
    }
  ],
  imports: [
    CommonModule
  ]
})
export class WmsSplitPanelComponent implements OnInit, AfterViewInit, OnDestroy {

  @Input() split: string = 'vertical';
  @Input() show: boolean = true;
  @Input() width: any = 0;
  @Input() height: any = 0;
  @Input() class: string = '';


  panes: any[] = [];
  isHorizontalSplit: boolean = false;

  private _el: any;
  private splitAdjustFn: any;
  private resizer: any;
  private resizeSubscription: Subscription;

  constructor() {
    const elementRef = inject(ElementRef);
    this._el = $(elementRef.nativeElement);
    this.resizer = inject(EventManagerService);

    this.resizeSubscription = this.resizer.onResize$().subscribe((size: any) => {
      if (this._el.is(':visible')) {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(this.autoResize.bind(this), 50, false);
      }
    });
  }


  ngOnInit() {
    if (this.split === 'vertical') {
      this.isHorizontalSplit = false;
    } else {
      this.isHorizontalSplit = true;
      this.split = 'horizontal';
    }
  }

  ngAfterViewInit() {
    //Close & expand panes on button click
    this._el.find('>.split-pane-divider button').on('click', () => {
      let $el = $(this),
        ival = $el.closest('.split-pane-divider').attr('data-index'),
        index: number = !ival ? 0 : (typeof(ival) === 'string' ? parseInt(ival) : ival);

        let pane1 = this.panes[index - 1],
        pane2 = this.panes[index];

      if ($el.hasClass('expand-bottom')) {
        pane1.height = '97%';
        pane2.height = 0;
      } else if ($el.hasClass('expand-top')) {
        pane1.height = 0;
        pane2.height = '97%';
      }
    });

    this._el.find('>.split-pane-divider').on('mousedown', ($event: any) => {
      let currentElement=$($event.target)
      let ival=currentElement.prop('tagName')==="SPAN" ? currentElement.closest('.split-pane-divider').data('index') : currentElement.data('index')
      let index: number = !ival ? 0 : (typeof(ival) === 'string' ? parseInt(ival) : ival),
        pane1 = this.panes[index - 1],
        pane2 = this.panes[index],
        from  = {'x': $event.pageX, 'y': $event.pageY};

      this.splitAdjustFn = this.splitManager(pane1, pane2, from, this.isHorizontalSplit);
      this._el.addClass('resizing');
      this.bindMouseEvts();
    });
  }

  splitManager(pane1: any, pane2: any, position: any, isHeight: any) {
    var lastPosition = position;
    pane1.computeDimensions(isHeight);
    pane2.computeDimensions(isHeight);
    return (currentPosition: any, isHeight: any) => {
      var diff = 0;
      if (isHeight) {
        diff = currentPosition.y - lastPosition.y;
      } else {
        diff = currentPosition.x - lastPosition.x;
      }
      if (diff > 0) {
        diff = -1 * pane2.computeMaxReduction(isHeight, -1 * diff);
      } else {
        diff = pane1.computeMaxReduction(isHeight, diff);
      }
      pane1.adjust(isHeight, diff);
      pane2.adjust(isHeight, -1 * diff);
      lastPosition = currentPosition;
    };
  }


  addPane($paneScope: WmsSplitPaneComponent) {
    this.panes.push($paneScope);
  }

  closePane(paneIndex: number) {
    var pane1         = this.panes[paneIndex],
      nextPaneIndex = paneIndex + (paneIndex + 1 === this.panes.length ? -1 : 1),
      pane2         = this.panes[nextPaneIndex];

    pane1.computeDimensions();
    pane2.computeDimensions();
    setTimeout(() => {
      if (this.isHorizontalSplit) {
        pane2.height     = pane1.height + pane2.height;
        pane1.lastHeight = pane1.height;
        pane1.height     = 0;
      } else {
        pane2.width     = pane1.width + pane2.width;
        pane1.lastWidth = pane1.width;
        pane1.width     = 0;
      }
    }, 0);
  }

  openPane(paneIndex: number) {
    var pane1         = this.panes[paneIndex],
      nextPaneIndex = paneIndex + (paneIndex + 1 === this.panes.length ? -1 : 1),
      pane2         = this.panes[nextPaneIndex],
      currentValue  = 0;

    pane1.computeDimensions();
    pane2.computeDimensions();
    if (this.isHorizontalSplit) {
      currentValue = pane1.height;
      pane1.height = pane1.height || pane1.lastHeight || pane1.limit;
      pane2.height = pane2.height - (pane1.height - currentValue);
    } else {
      currentValue = pane1.width;
      pane1.width  = pane1.width || pane1.lastWidth || pane1.limit;
      pane2.width  = pane2.width - (pane1.width - currentValue);
    }
  }

  unbindMouseEvts() {
    this._el.off('.splitPaneEvts');
  }
  
  bindMouseEvts() {
    this._el.on('mousemove.splitPaneEvts',  ($event:any)=> {
      if (this.splitAdjustFn) {
        this.splitAdjustFn({'x': $event.pageX, 'y': $event.pageY}, this.isHorizontalSplit);
      }
    });
  
    this._el.on('mouseup.splitPaneEvts mouseleave.splitPaneEvts', ($event:any)=> {
      if (this.splitAdjustFn) {
        this.splitAdjustFn({'x': $event.pageX, 'y': $event.pageY}, this.isHorizontalSplit);
        this._el.removeClass('resizing');
      }
      this.splitAdjustFn = null;
      this.unbindMouseEvts();
    });
  }

  /**
   * Resizes the internal panels based on the current dimensions.
   */
  autoResize() {
    let previousDim = 0,
      resizedDim: number = 0;

    $.each(this.panes, function () {
      this.computeDimensions(this.isHorizontalSplit);
    });

    if (this.isHorizontalSplit) {
      resizedDim = this._el.height() as number;
      $.each(this.panes, function () {
        previousDim += this.height;
      });

      $.each(this.panes, function () {
        this.height = Math.floor((this.height / previousDim) * resizedDim);
      });
    } else {
      resizedDim = this._el.width() as number;
      $.each(this.panes, function () {
        previousDim += this.width;
      });
      $.each(this.panes, function () {
        this.width = Math.floor((this.width / previousDim) * resizedDim);
      });
    }
  }

  ngOnDestroy() {
    if (this.resizeSubscription) {
      this.resizeSubscription.unsubscribe();
    }
    this._el.find('>.split-pane-divider button').off('click');
    this._el.find('>.split-pane-divider').off('mousedown');
  }

}
